import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthGuard } from '../../components/AuthGuard';
import TmsAccountPage from './account/TmsAccountPage';
import VehiclePage from './vehicle/VehiclePage'
import RoutePage from './route/RoutePage';
import ShipFromHereTask from './task/ShipFromHereTask';
import ShipToHereTask from './task/ShipToHereTask';
import SchedulePage from './schedule/SchedulePage';
import TmsDownloadPage from './download/TmsDownloadPage';
import TransitManagementPage from './transit/TransitManagementPage';
import TmsLayout from "./layouts/TmsLayout";

const TmsRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<AuthGuard><TmsLayout /></AuthGuard>}>
                <Route path="task/shipFromHere" element={<AuthGuard><ShipFromHereTask /></AuthGuard>} />
                <Route path="task/shipToHere" element={<AuthGuard><ShipToHereTask /></AuthGuard>} />
                <Route path="transit" element={<AuthGuard><TransitManagementPage /></AuthGuard>} />
                <Route path="route" element={<AuthGuard><RoutePage /></AuthGuard>} />
                <Route path="schedule" element={<AuthGuard><SchedulePage /></AuthGuard>} />
                <Route path="personnel" element={<AuthGuard><TmsAccountPage/> </AuthGuard>} />
                <Route path="vehicle" element={<AuthGuard><VehiclePage/></AuthGuard>} />
                <Route path="download" element={<AuthGuard><TmsDownloadPage /></AuthGuard>} />
            </Route>

        </Routes>
    );
};

export default TmsRoutes;
